import React from 'react';
import { Provider } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import Routes from './routes';

import store from './store';
import Loading from './components/Loading';

const App = () => {
  return (
    <Provider store={store}>
      <CssBaseline />
      <Routes />
      <Loading />
    </Provider>
  );
};

export default App;
